import React from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { LinkProps, useNavigate } from 'react-router-dom';
import { Button, COLOR_BASE_500, useTheme } from '..';

interface BackButtonProps extends LinkProps {
  buttonText?: string;
  className?: string;
  primary?: boolean;
}

export const BackButton = ({ to, buttonText, primary = true, className }: BackButtonProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { textColor } = useTheme();

  return (
    <Button
      icon={<ArrowLeftOutlined />}
      type="text"
      onClick={() => navigate(to)}
      className={cx('text-base-600 px-1 w-fit mb-2 text-sm md:text-base', className)}
      style={{ color: primary ? textColor : COLOR_BASE_500 }}
    >
      {buttonText ?? t('common.back_to_search')}
    </Button>
  );
};
